module.exports = __webpack_public_path__ + "img/zimpler.f721aa4f.svg";